/* bb-search-ql.js (search package, round 5, 2026-10-14)
   "Popular ways to shop" (snippets/bb-search-quicklinks.liquid): By Intention, By Origin, By Chakra
   and By Zodiac open a second set of small round photos in place of the first, with a Back button.
   The second sets are listed in the page as data (data-bb-ql-items: name|link|photo|framing, ~ between
   entries; data-bb-ql-more: name|link) and built here the first time a set opens, so the page stays
   light. Bound once per page; also works for rows the search pop-up adds later (a search with no
   results). Loaded with defer, cached across pages. */
(function () {
  if (window.bbQl) return;
  window.bbQl = 1;

  function tile(f) {
    var a = document.createElement('a');
    a.className = 'bb-ql__tile';
    a.href = f[1];
    var box = document.createElement('span');
    box.className = 'bb-ql__img';
    if (f[2]) {
      var sep = f[2].indexOf('?') > -1 ? '&' : '?';
      var img = document.createElement('img');
      var v = f[3] ? f[3].split(',') : null;
      var sc = v ? parseFloat(v[0]) || 1 : 1;
      var u = function (w) { return f[2] + sep + 'width=' + w + ' ' + w + 'w'; };
      /* sizes = the drawn size (circle times framing scale): 128px on a phone, 192px on a sharp phone, 96px on a computer */
      img.sizes = '(min-width: 750px) ' + Math.ceil(72 * sc) + 'px, ' + Math.ceil(64 * sc) + 'px';
      img.srcset = [u(96), u(128), u(192)].concat(sc > 1.2 ? [u(256)] : []).join(', ');
      img.src = f[2] + sep + 'width=128';
      img.alt = '';
      img.width = 64;
      img.height = 64;
      img.decoding = 'async';
      if (v) img.style.cssText = '--s:' + v[0] + ';--tx:' + v[1] + '%;--ty:' + v[2] + '%';
      box.appendChild(img);
    }
    var nm = document.createElement('span');
    nm.className = 'bb-ql__name';
    nm.textContent = f[0];
    a.appendChild(box);
    a.appendChild(nm);
    return a;
  }

  function fill(p) {
    if (!p || p.bbQlFilled) return;
    p.bbQlFilled = 1;
    var grid = p.querySelector('[data-bb-ql-items]');
    if (grid) {
      var items = (grid.getAttribute('data-bb-ql-items') || '').split('~');
      for (var i = 0; i < items.length; i++) {
        var f = items[i].split('|');
        if (f[0] && f[1]) grid.appendChild(tile(f));
      }
    }
    var more = p.querySelector('[data-bb-ql-more]');
    if (more) {
      var names = (more.getAttribute('data-bb-ql-more') || '').split('~');
      var n = 0;
      for (var j = 0; j < names.length; j++) {
        var m = names[j].split('|');
        if (!m[0] || !m[1]) continue;
        n++;
        var a = document.createElement('a');
        a.href = m[1];
        a.textContent = m[0];
        more.appendChild(a);
      }
      if (!n) more.hidden = true;
    }
  }

  function show(r, key, back, kbd) {
    var main = r.querySelector('[data-bb-ql-main]');
    /* a smaller set keeps the height of the first one, so the pop-up does not jump */
    if (key && main && !main.hidden) r.style.minHeight = r.offsetHeight + 'px';
    if (!key) r.style.minHeight = '';
    var ps = r.querySelectorAll('[data-bb-ql-panel]');
    for (var i = 0; i < ps.length; i++) {
      var on = ps[i].getAttribute('data-bb-ql-panel') === key;
      if (on) fill(ps[i]);
      ps[i].hidden = !on;
    }
    var bs = r.querySelectorAll('[data-bb-ql-open]');
    for (var j = 0; j < bs.length; j++) bs[j].setAttribute('aria-expanded', bs[j].getAttribute('data-bb-ql-open') === key ? 'true' : 'false');
    if (main) main.hidden = !!key;
    if (!kbd) return;
    var t = key ? r.querySelector('[data-bb-ql-panel="' + key + '"] [data-bb-ql-back]') : (back ? r.querySelector('[data-bb-ql-open="' + back + '"]') : null);
    if (t) t.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-bb-ql-open], [data-bb-ql-back]') : null;
    var r = t ? t.closest('[data-bb-ql]') : null;
    if (!r) return;
    e.preventDefault();
    var kbd = e.detail === 0; /* keyboard: move focus to Back, and back to the photo that opened the set */
    if (t.hasAttribute('data-bb-ql-open')) {
      r.bbQlFrom = t.getAttribute('data-bb-ql-open');
      show(r, r.bbQlFrom, '', kbd);
    } else {
      show(r, '', r.bbQlFrom, kbd);
    }
  });

  /* The theme's search box treats any key released inside the pop-up as "clear the box and go back to
     it", so Tab always landed back in the box and these photos could not be reached from the keyboard.
     Keys released on these photos, and Tab anywhere in the pop-up, stop here. */
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' || !e.target || !e.target.closest) return;
    if (e.target.closest('[data-bb-ql]') || (e.key === 'Tab' && e.target.closest('.search-modal'))) e.stopPropagation();
  }, true);

  /* closing the pop-up resets it to the first set */
  document.addEventListener('searchmodal:close', function () {
    var rs = document.querySelectorAll('[data-bb-ql]');
    for (var i = 0; i < rs.length; i++) show(rs[i], '', '', false);
  });
})();
